export function parseDashboardForPayeeResponse(data) {
  if (data == null || typeof data !== 'object' || Array.isArray(data)) {
    return null;
  }

  return {
    commissionsTrend: data.commissionsTrend ?? null,
    carriersByCommissionPercentage: data.carriersByCommissionPercentage ?? null
  };
}
